import React from 'react'
import styled from 'styled-components'
import { FA } from 'src/assets'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Link, useLocation } from 'react-router-dom'
const QuestionWrapper = styled.div`
  padding-top: 23px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  h1 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x1};
    line-height: 32px;
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
  .card {
    padding: 10px 33px;
    background: #f29339;
    border-radius: 10px;
  }
  .two {
    display: flex;
  }
  h6 {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    font-weight: 500;
  }
  h3 {
    font-weight: 900;
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 24px;
    color: ${({ theme }) => theme.colors.dark};
    padding-left: 36.5px;
  }
  input {
    margin-top: -20px;
  }
  .group {
    margin-top: -10px;
    margin-bottom: 6px;
  }
  .cards {
    overflow-y: scroll;
    height: 410px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    ::-webkit-scrollbar {
      display: none;
    }
  }
  .confirm {
    margin-top: 20px;
  }
`
const SecurityQuestion = () => {
  let location = useLocation()
  return (
    <QuestionWrapper>
      <h1>Set a security question</h1>
      <h6 className="group">Set a security question</h6>
      <div className="cards">
        <div className="card">
          <div className="two">
            <img src={FA} alt="" />
            <h3> TAP TO CREATE OTP!</h3>
          </div>
          <h6>
            2FA is required to complete this process for your own safety. Please
            tap to generate OTP then come back to proceed. Set a personal
            security.
          </h6>
        </div>
        <div className="amount">
          <h6>Ask a personal security question</h6>
          <QuicksaveInput
            type="text"
            name="Amount"
            placeholder="e.g, what was your first car?"
          />
        </div>
        <div className="amount">
          <h6>Type your answer here</h6>
          <QuicksaveInput type="text" name="Amount" placeholder="e.g,Honda" />
        </div>
      </div>
      <div>
        <Link to={`/big/token-sent`} state={{ backgroundLocation: location }}>
          <ModalButton className="confirm">Set Security Question</ModalButton>
        </Link>
      </div>
    </QuestionWrapper>
  )
}

export { SecurityQuestion }
